import camelCase from 'lodash.camelcase';
import mapKeys from 'lodash.mapkeys';

/**
 * Normalizes object schema by removing underscore prefixes and converting keys to camelCase
 * @param obj - The object to normalize
 * @returns The object with all nested keys normalized
 */
export function normalizeSchema<T = unknown>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(normalizeSchema) as T;
  }

  if (obj !== null && typeof obj === 'object') {
    const converted = mapKeys(obj as Record<string, unknown>, (_, key) => {
      // First remove underscore prefix if present
      const keyWithoutUnderscore = key.startsWith('_') ? key.substring(1) : key;
      // Then convert to camelCase
      return camelCase(keyWithoutUnderscore);
    });

    return Object.fromEntries(
      Object.entries(converted).map(([key, value]) => [
        key,
        normalizeSchema(value),
      ]),
    ) as T;
  }

  return obj;
}
